/**
 * Configuration:
 * data-toggle="confirmation"               - enables confirmation modal    (mandatory)
 * data-title="Delete confirmation"         - title of modal                (mandatory)
 * data-content="Are you sure?"             - question                      (mandatory)
 * data-btn-ok-label="Yes"                  - Label of OK button            (mandatory)
 * data-btn-ok-class="btn-primary"          - Class of OK button            (optional)
 * data-btn-cancel-label="No"               - Label of CANCEL button        (mandatory)
 * data-btn-cancel-class="btn-secondary"    - Class of CANCEL button        (optional)
 */
Bingo.Bootstrap = {};
Bingo.Bootstrap.Confirmation = {};
Bingo.Bootstrap.Confirmation.$template = null;
Bingo.Bootstrap.Confirmation.init = function ($container) {
    const elements = $container.find('[data-toggle=confirmation]:not([data-confirmation=true])');
    elements.attr('data-confirmation', true);
    elements.click(function (e, options) {
        options = options || {};
        // Continue in normal operations
        if (options.confirmed) {
            return true;
        }
        const clickedElement = e.currentTarget;
        if (clickedElement.type === 'submit' && clickedElement.form) {
            if (!Nette.validateForm(clickedElement.form)) {
                return false;
            }
        }
        // Load configuration and provide reasonable fallback values (for optional options)
        const data = $(this).data();
        e.stopImmediatePropagation();
        e.preventDefault();

        const self = $(this);

        Bingo.Bootstrap.Confirmation.show({
            ...data,
            onConfirm() {
                self.attr('data-confirmed', true);
                $(e.currentTarget).trigger(e.type, { confirmed: true });
            },
        });

        return false;
    });
    // WORKAROUND: Fix redirect after click on link.
    elements.filter('a[href]:not(.ajax)').click(function (e, options) {
        options = options || {};
        if (options.confirmed) {
            window.location.href = $(this).attr('href') || '';
        }
    });
};

/**
 * Options:
 * {
 *     title,
 *     content,
 *     btnOkLabel,
 *     btnCancelLabel,
 *     onConfirm
 * }
 */
Bingo.Bootstrap.Confirmation.show = function (options) {
    const id = Math.random().toString(36).substring(7);
    const $modal = Bingo.Bootstrap.Confirmation.prepareTemplate(id, {
        title: options.title,
        content: options.content,
        btnOkLabel: options.btnOkLabel,
        btnCancelLabel: options.btnCancelLabel,
    });
    $('body').append($modal);

    $modal.find('button.yes').click(() => {
        options.onConfirm();
    });

    $modal.on('hidden.bs.modal', function () {
        $(this).data('bs.modal', null);
        $(this).remove();
    });

    $modal.modal();
};

Bingo.Bootstrap.Confirmation.prepareTemplate = function (id, data) {
    const $modal = Bingo.Bootstrap.Confirmation.$template.clone();

    $modal.attr('id', `confirm-modal-${id}`);
    $modal.find('.modal-title').text(data.title);
    $modal.find('.modal-body').text(data.content);
    $modal.find('button.yes').text(data.btnOkLabel);
    $modal.find('button.no').text(data.btnCancelLabel);

    return $modal;
};

// Find modal template in DOM.
(function ($) {
    Bingo.Bootstrap.Confirmation.$template = $('#confirmation-template');
    Bingo.Bootstrap.Confirmation.$template.remove();
}(jQuery));

// This piece of code prevents ajax request to be triggered until the confirmation is confirmed
(function ($) {
    $.nette.ext('confirmation', {
        init() {
            this.ext('snippets', true).after($.proxy(($el) => {
                Bingo.Bootstrap.Confirmation.init($($el));
            }, this));
        },
        before(xhr, settings) {
            if (!settings.nette) {
                return null;
            }
            const hasConfirmation = settings.nette.el.data('confirmation');
            const isConfirmed = settings.nette.el.data('confirmed');
            if (!hasConfirmation || isConfirmed) {
                return true;
            }
            return false;
        },
    }, {});
}(jQuery));
